import FtesePerOferte from "../Assets/Documents/FTESE PER OFERTE DPA.pdf";
import "./fteseOferte.css";
const FteseOferte = () => {
  return (
    <div className="ftese-oferte">
      <a href={FtesePerOferte} target="_blank" rel="noopener noreferrer">
        Ftesë për ofertë për Operatorët Ekonomikë për ofrimin e shërbimit për
        “Organizimin e Aktivitetit Kulturor për Ekspozimin e Fondeve Arkivore në
        Muzeun e DPA”
      </a>
    </div>
  );
};

export default FteseOferte;
